/** Formatting helpers for the admin usage dashboard (QUERI-821). */

const FEATURE_LABELS: Record<string, string> = {
  qagent: 'QAgent',
  qagentFallback: 'QAgent (fallback model)',
  'qagent-title': 'Chat titles',
  'qagent-parallel-review': 'QAgent parallel review',
  toolChat: 'Tool Chat',
  contract: 'Contract drafting (v1)',
  contractV2: 'Contract drafting',
  playbooks: 'Playbooks',
  review: 'Document review',
  redlineSummary: 'Redline summaries',
  intentRouter: 'Intent routing',
  language: 'Language detection',
  meetingAi: 'Meeting AI',
  meetingContract: 'Meeting → contract',
  chat: 'Q-Chat',
  paragraph: 'Paragraph drafting',
  'project-chat': 'Project chat',
  fileSearch: 'File search (Gemini)',
  embeddings: 'Embeddings',
};

export const featureLabel = (key: string) =>
  FEATURE_LABELS[key] ??
  key
    .replace(/[-_]/g, ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/^./, (c) => c.toUpperCase());

export const formatTokens = (n: number) => {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}K`;
  return n.toLocaleString();
};

export const formatNumber = (n: number) => n.toLocaleString();
